import createHistory from 'history/createBrowserHistory';

// A singleton history object for easy API navigation
const history = createHistory();
export default history;



// WEBPACK FOOTER //
// ./src/common/history.js